var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgmMap } from '@agm/core';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, ElementRef, OnInit, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../config/config';
import { VisitorSettingsCommand, VisitorTripIdCommand, } from '../../../commands/pagination.query.command';
import { AllFrontendSettingsCommand, HubVisitorRegion } from '../../../commands/visitor/all.frontend.settings.command';
import { CreateTripCommand, TripStorageCommand } from '../../../commands/visitor/create.trip.command';
import { BaseComponent } from '../../../common/components/base.component';
import { FieldComponent } from '../../../common/components/field/field.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { SearchComponent } from '../../../common/components/search/search.component';
import { SelectComponent } from '../../../common/components/select/select.component';
import { SocialLoginPopupComponent } from '../../../common/components/social.login.popup/social.login.popup.component';
import { WaterFallContainerComponent } from '../../../common/components/water.fall.container/water.fall.container.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { bindFunctionsToThis, clone, isNullOrUndefined } from '../../../common/extensions';
import { GoogleMapsService } from '../../../common/services/google.maps.service';
import { ModalService } from '../../../common/services/modal.service';
import { HubTour } from '../../../models/hub/hub.tour';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { ImageService } from '../../../services/image.service';
import { LocalStorageService } from '../../../services/localStorageService';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { AllFrontendSettingsStore, VisitorCalendarStore, VisitorDataCache, VisitorTripIdStore, VisitorTripStore, } from '../../../stores/visitor.calendar.store';
import { guid } from '../../../utils/guid';
import { DirectionPlanComponent } from '../../hub/tours/direction.plan/direction.plan.component';
import { BlockNavigatorComponent } from './block.navigator/block.navigator.component';
import { TripMapBottomInfoComponent } from './trip.map.bottom.info/trip.map.bottom.info.component';
import { VisitorTripSideBarComponent } from './trip.side.bar/visitor.trip.side.bar.component';
import 'rxjs/add/operator/retryWhen';
import 'rxjs/add/operator/delay';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { StyleModel } from '../../../commands/hub/style.command';
import { Location } from '@angular/common';
import { EditorChoiceStore } from '../../../stores/hub.calendar.store';
var VisitorTripComponent = /** @class */ (function (_super) {
    __extends(VisitorTripComponent, _super);
    function VisitorTripComponent(router, activatedRoute, visitorCalendarStore, imageService, googleMapService, visitorTripStore, visitorTripIdStore, visitorApiService, allFrontendSettingsStore, customizationApiService, formBuilder, ref, location, editorChoiceStore, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.imageService = imageService;
        _this.googleMapService = googleMapService;
        _this.visitorTripStore = visitorTripStore;
        _this.visitorTripIdStore = visitorTripIdStore;
        _this.visitorApiService = visitorApiService;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.customizationApiService = customizationApiService;
        _this.formBuilder = formBuilder;
        _this.ref = ref;
        _this.location = location;
        _this.editorChoiceStore = editorChoiceStore;
        _this.modalService = modalService;
        _this.isStarted = false;
        _this.isForExportPDF = false;
        _this.isPrintVersion = false;
        _this.isForTourList = false;
        _this.isForSingleTour = false;
        _this.isSearchDisabled = false;
        _this.today = new Date();
        _this.searchFormGroup = _this.formBuilder.group({
            search: [null],
            searchCity: [null],
        });
        _this.isPlanStarted = false;
        _this.loadingTip = 'Loading...';
        _this.isLoggedIn = false;
        _this.isShowDirectionMap = false;
        _this.isShowNormalMap = false;
        _this.mapBottomInfoIndex = -1;
        _this.isNormalMapReady = false;
        _this.isShowTour = false;
        _this.isNoContent = false;
        _this.isShowWelcomepageNoEventTip = false;
        _this.isShowSidebarOnMobile = false;
        _this.isShowFloatDetail = false;
        _this.isShowfloatDetailPlaceFeeds = false;
        _this.welcomeImg = config.tripPlannerWelcomeImg;
        _this.tripTour = new HubTour();
        _this.isInfoWindowsOpen = [];
        _this.arrowImg = config.arrow;
        _this.detailSelectedMapMarker = config.detailSelectedMapMarker;
        _this.hideIconMapStyler = config.google.hideMapBusinessIconStyles;
        _this.placeMapIcon = {
            Accommodations: config.tripPlanner.placeMapIcon.accommodation,
            'Arts & Culture': config.tripPlanner.placeMapIcon.arts,
            'Dining & Nightlife': config.tripPlanner.placeMapIcon.dinging,
            Activities: config.tripPlanner.placeMapIcon.activity,
            Shopping: config.tripPlanner.placeMapIcon.shopping,
            'Outdoors & Fitness': config.tripPlanner.placeMapIcon.outdoor,
            Entertainment: config.tripPlanner.placeMapIcon.entertainment,
            Transportation: config.tripPlanner.placeMapIcon.transportation,
            Other: config.tripPlanner.placeMapIcon.other,
            Event: config.tripPlanner.eventMapIcon,
        };
        _this.lat = 0;
        _this.lng = 0;
        _this.tpHomeImageUrl = '';
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.loadingRegion = false;
        _this.isShowGDPR = false;
        _this.isMultiCityBlock = true;
        _this.allRegions = [];
        _this.allRegionsInOne = new HubVisitorRegion();
        _this.noCities = false;
        _this.profileImage = '';
        _this.allFrontendSettings = new AllFrontendSettingsCommand();
        _this.style = new StyleModel();
        bindFunctionsToThis(_this);
        return _this;
    }
    VisitorTripComponent.prototype.ngOnInit = function () {
        this.pageSpinner.show();
        this.welcomeImg = this.imageService.imageSourceUrl(this.welcomeImg);
        this.checkGDPR();
    };
    VisitorTripComponent.prototype.ngAfterViewInit = function () {
        var _a = this.allRouteParams, hubName = _a.hubName, tripId = _a.tripId, tourId = _a.tourId, singleTripId = _a.singleTripId, pdf = _a.pdf, version = _a.version, tourOrTrip = _a.tourOrTrip, tourOrTripId = _a.tourOrTripId, regionId = _a.regionId;
        this.hubName = hubName;
        this.regionId = regionId;
        this.detailSelectedMapMarker = this.imageService.imageSourceUrl(this.detailSelectedMapMarker);
        this.loadSettings(regionId);
        this.urlTripID = tripId;
        // this is for exporting PDF from mobile in side the iFrame.
        // Because iOS shows PDF from this scenario as an image and only shows the first page
        // So when exporting PDF from mobile in side the iFrame,
        // we give the user a link which could redirect to ImGoing directly and start exporting the PDF automatically
        this.forPDFDownload(pdf, version, tourOrTrip, tourOrTripId);
        // show single tour view
        this.forSingleTourView(tripId, singleTripId);
        // show itinerary list view
        this.forItineraryListView(tripId);
        // show user shared trip view
        // tripId: the whole trip ID, singleTripId: one single day trip ID of a whole trip
        this.forUserSharedTrip(tripId, singleTripId);
        this.getEditorChoiceText();
    };
    VisitorTripComponent.prototype.hashChanged = function ($event) {
        var _this = this;
        if (this.isScriptSolution) {
            var url_1 = this.router.url;
            console.log('back btn in trip', this.router.url);
            // some sites may redirect to auth page, e.g., https://take321.com/
            this.location.go(this.location.path().replace('/auth', '/'));
            setTimeout(function () {
                _this.router.navigateByUrl(url_1, { skipLocationChange: _this.noChangeUrlWhenRedirect });
            }, 100);
        }
    };
    VisitorTripComponent.prototype.getEditorChoiceText = function () {
        var _this = this;
        this.customizationApiService.getEditorChoice(this.hubName).subscribe(function (editorChoice) {
            if (!editorChoice)
                return;
            editorChoice.editorChoiceForEvent = editorChoice.editorChoiceForEvent || "EDITOR'S CHOICE";
            editorChoice.editorChoiceForPlace = editorChoice.editorChoiceForPlace || "EDITOR'S CHOICE";
            _this.editorChoiceStore.infoCommand.next(editorChoice);
        });
    };
    VisitorTripComponent.prototype.loadSettings = function (regionId) {
        var _this = this;
        /**
         * CalhounAL has a strange issue -- refresh the trip planner page from its inside button could cause trip planner continues showing loading icon, which is a 504 error when loading the settings,
         * so here temporarily load it from local storage
         * TODO check more on this issue
         * https://trello.com/c/yebQz3He/835-bug-event-and-trip-planner-widget-not-loading-after-nav-away-from-page
         * */
        var settingsStr = localStorage.getItem(localStorageKeys.allFrontendSettingsForTP);
        if (this.hubName === 'CalhounAL' && settingsStr) {
            var settings_1 = JSON.parse(settingsStr);
            console.log('load settings from local storage', settings_1);
            setTimeout(function () {
                _this.processSettings(settings_1, regionId);
            });
            setTimeout(function () {
                _this.customizationApiService.getAllFrontendSettingsForTP(_this.hubName, regionId).subscribe(function (allSettings) {
                    localStorage.setItem(localStorageKeys.allFrontendSettingsForTP, JSON.stringify(allSettings));
                    console.log('settings refreshed');
                });
            }, 1000);
        }
        else {
            this.customizationApiService
                .getAllFrontendSettingsForTP(this.hubName, regionId)
                .retryWhen(function (errors) { return errors.delay(1000).take(3); })
                .catch(function (err) {
                throw 'getAllFrontendSettingsForTP: ' + err;
            })
                .subscribe(function (allSettings) {
                if (!allSettings) {
                    alert("Account " + _this.hubName + " not found, please verify!");
                }
                localStorage.setItem(localStorageKeys.allFrontendSettingsForTP, JSON.stringify(allSettings));
                localStorage.setItem(localStorageKeys.timezoneFormatterDefault, allSettings.timezoneFormatter);
                _this.processSettings(allSettings, regionId);
            });
        }
    };
    VisitorTripComponent.prototype.forUserSharedTrip = function (tripId, singleTripId) {
        var _this = this;
        if (tripId && ['trip', 'tour', 'tour-list'].indexOf(tripId) < 0) {
            this.getTripsFromDBByTripID(this.urlTripID).subscribe(function (trip) {
                if (trip) {
                    _this.urlTripFromUserID = trip.userFacebookId;
                    if (singleTripId) {
                        trip.trips = trip.trips.filter(function (x) { return x.id === singleTripId; });
                    }
                    _this.setLocalStorageForSharedTrip(trip, trip.userFacebookId, true);
                }
                else {
                    window.location.href = config.serverDomain + 'assets/pages/404.html';
                }
            });
        }
    };
    VisitorTripComponent.prototype.forItineraryListView = function (tripId) {
        var _this = this;
        if (tripId === 'tour-list') {
            this.isForTourList = true; // hide other irrelevant elements
            if (this.isMobile) {
                this.isShowSidebarOnMobile = true;
            }
            setTimeout(function () {
                _this.sidebar && _this.sidebar.switchToTours();
            }, 300);
        }
    };
    VisitorTripComponent.prototype.forSingleTourView = function (tripId, singleTripId) {
        var _this = this;
        if (tripId === 'tour' && singleTripId) {
            this.urlTourID = singleTripId;
            this.isForTourList = true; // hide other irrelevant elements
            this.isForSingleTour = true;
            if (this.isMobile) {
                this.isShowSidebarOnMobile = true;
            }
            setTimeout(function () {
                _this.sidebar && _this.sidebar.switchToTours(singleTripId);
            }, 300);
            // return;
        }
    };
    VisitorTripComponent.prototype.forPDFDownload = function (pdf, version, tourOrTrip, tourOrTripId) {
        var _this = this;
        if (pdf === 'pdf') {
            this.isPrintVersion = version === 'print';
            this.isForExportPDF = true;
            this.loadingTip = 'Loading PDF...';
            if (tourOrTrip === 'tour') {
                this.urlTourID = tourOrTripId;
                setTimeout(function () {
                    _this.sidebar.switchToTours(tourOrTripId);
                }, 600);
            }
            else {
                setTimeout(function () {
                    _this.visitorApiService.getTripTemp(_this.hubName, tourOrTripId).subscribe(function (trip) {
                        console.log(trip);
                        var items = JSON.parse(trip.trips);
                        if (!isNullOrUndefined(items.length)) {
                            // all trips
                            _this.sidebar.printTourOrTrip(items, _this.isPrintVersion);
                        }
                        else {
                            // single trip
                            _this.sidebar.printTourOrTrip([items], _this.isPrintVersion);
                        }
                    });
                    // return;
                }, 600);
            }
            if (this.isMobile) {
                this.isShowSidebarOnMobile = true;
            }
            this.pageSpinner.show();
            // return;
        }
    };
    VisitorTripComponent.prototype.processSettings = function (allSettings, regionId) {
        var _this = this;
        if (allSettings.toggles) {
            this.featuresToggle = allSettings.toggles;
        }
        this.allFrontendSettings.toggle = this.featuresToggle;
        this.allFrontendSettings.regions = allSettings.regions;
        this.allFrontendSettings.customSettings = new VisitorSettingsCommand();
        this.allFrontendSettings.customSettings.placeImagesShownCount = allSettings.placeImagesShownCount;
        this.allFrontendSettings.customSettings.tripPlannerDetailsStyle = allSettings.tpDetailsStyle;
        this.allFrontendSettings.dataSource = allSettings.dataSource;
        this.allFrontendSettings.style = allSettings.style;
        this.allFrontendSettings.customSettings.customDefaultPlaceCategory = allSettings.customDefaultPlaceCategory;
        if (allSettings.multiCityBlock) {
            this.isMultiCityBlock = isNullOrUndefined(allSettings.multiCityBlock.active)
                ? true
                : allSettings.multiCityBlock.active;
        }
        if (allSettings.regions && allSettings.toggles.multipleCities) {
            this.setMultipleCities(allSettings, regionId);
        }
        if (!this.featuresToggle.multipleCities) {
            this.tpHomeImageUrl =
                isNullOrUndefined(allSettings.tpHomeImage) ||
                    isNullOrUndefined(allSettings.tpHomeImage.isDefault) ||
                    allSettings.tpHomeImage.isDefault
                    ? null
                    : allSettings.tpHomeImage.url;
            if (this.tpHomeImageUrl) {
                this.tpHomeImageUrl = this.imageService.imageSourceUrl(this.tpHomeImageUrl);
            }
        }
        // let tourSidebarImage = (isNullOrUndefined(allSettings.tourSidebarImage) || isNullOrUndefined(allSettings.tourSidebarImage.isDefault) || allSettings.tourSidebarImage.isDefault) ? null : allSettings.tourSidebarImage.url;
        // this.allFrontendSettings.customSettings.tourSidebarImage = { isDefault: allSettings.tourSidebarImage.isDefault, url: tourSidebarImage};
        this.allFrontendSettings.customSettings.tourSidebarImage = allSettings.tourSidebarImage;
        var logoUrl = isNullOrUndefined(allSettings.logo) || isNullOrUndefined(allSettings.logo.isDefault) || allSettings.logo.isDefault
            ? config.defaultLogoUrl
            : allSettings.logo.url;
        VisitorDataCache.logo = this.imageService.imageSourceUrl(logoUrl);
        VisitorDataCache.placeCategories = allSettings.placeCategories;
        if (allSettings.style) {
            Object.keys(allSettings.style.tripPlanner).forEach(function (x) {
                _this.style.tripPlanner[x].color.value =
                    allSettings.style.tripPlanner[x].color || _this.style.tripPlanner[x].color.value;
            });
            this.allFrontendSettings.style = this.style;
        }
        this.allFrontendSettingsStore.allFrontendSettingsCommand.next(this.allFrontendSettings);
        if (!this.isForExportPDF) {
            this.pageSpinner.hide();
        }
    };
    VisitorTripComponent.prototype.ngAfterViewChecked = function () {
        this.setCustomColor();
        this.ref.detectChanges();
    };
    VisitorTripComponent.prototype.setCustomColor = function () {
        if (!this.tripWrap)
            return;
        try {
            var dateIcons = this.tripWrap.nativeElement.querySelectorAll('.ig-date-field svg');
            for (var i = 0; i < dateIcons.length; i++) {
                dateIcons[i].style.color = this.style.tripPlanner.buttons.color.value;
            }
            var startBtn = this.tripWrap.nativeElement.querySelector('.trip-start button');
            startBtn && (startBtn.style.backgroundColor = this.style.tripPlanner.buttons.color.value);
            var submitBtns = this.tripWrap.nativeElement.querySelectorAll('.submit-wrap button');
            for (var i = 0; i < submitBtns.length; i++) {
                submitBtns[i].style.backgroundColor = this.style.tripPlanner.buttons.color.value;
            }
            var loginBtn = this.tripWrap.nativeElement.querySelector('.trip .login-with-fb ig-button button');
            loginBtn && (loginBtn.style.backgroundColor = this.style.tripPlanner.trip.color.value);
            var loginBtnMobile = this.tripWrap.nativeElement.querySelector('.trip ig-social-login-popup ig-button button');
            loginBtnMobile &&
                (loginBtnMobile.style.backgroundColor = this.style.tripPlanner.trip.color.value);
            var head = document.getElementsByTagName('head')[0];
            var s = document.createElement('style');
            s.setAttribute('type', 'text/css');
            var css = '';
            if (this.style.tripPlanner.tour.color.value) {
                css += "--tour-btn-background-color: " + this.style.tripPlanner.tour.color.value + ";";
            }
            if (this.style.tripPlanner.trip.color.value) {
                css += "--trip-btn-background-color: " + this.style.tripPlanner.trip.color.value + ";";
            }
            s.appendChild(document.createTextNode("\n                    :root {\n                    " + css + "\n                    }\n                "));
            head.appendChild(s);
        }
        catch (e) {
            console.error('Error in setCustomColor', e);
        }
    };
    Object.defineProperty(VisitorTripComponent.prototype, "isUserLoggedIn", {
        get: function () {
            return SocialLoginPopupComponent.isUserLoggedIn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripComponent.prototype, "isEventEnabled", {
        get: function () {
            return this.featuresToggle.manualEvents || this.featuresToggle.eventByGeolocation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripComponent.prototype, "isShowingEventOrPlace", {
        get: function () {
            return this.sidebar ? this.sidebar.displayingOn === 'event' || this.sidebar.displayingOn === 'place' : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripComponent.prototype, "mapSectionWidth", {
        get: function () {
            var width = this.isShowingEventOrPlace
                ? this.isSmallestPC
                    ? 'calc(33% - 16px)'
                    : 'calc(41.6667% - 16px)'
                : 'calc(70% - 16px)';
            return this.isMobile
                ? '100%'
                : this.isShowFloatDetail
                    ? this.isShowfloatDetailPlaceFeeds
                        ? "calc(" + width + " - 660px)"
                        : "calc(" + width + " - 330px)"
                    : width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripComponent.prototype, "placeHolderWidth", {
        get: function () {
            return this.isShowFloatDetail ? (this.isShowfloatDetailPlaceFeeds ? '660px' : '330px') : '0';
        },
        enumerable: true,
        configurable: true
    });
    VisitorTripComponent.prototype.goToSubmitPage = function (where) {
        var path = getRouteUrl(routeConfigs.submit[where], {
            hubName: this.hubName,
        });
        console.log({ path: path });
        this.router.navigateByUrl(path, { skipLocationChange: this.noChangeUrlWhenRedirect });
    };
    VisitorTripComponent.prototype.checkGDPR = function () {
        var acceptCookie = localStorage.getItem(localStorageKeys.GDPRAcceptCookie);
        if (!acceptCookie) {
            this.isShowGDPR = true;
        }
    };
    VisitorTripComponent.prototype.acceptCookie = function () {
        localStorage.setItem(localStorageKeys.GDPRAcceptCookie, 'true');
        this.isShowGDPR = false;
    };
    // actually this process (handle the login button styles) is not necessary, as the login button component would handle it.
    // But we have to use two login button components to achieve client's design on multiple cities trip planner. So it comes up with some style issues, which are handled here
    VisitorTripComponent.prototype.socialLoggedIn = function (status) {
        var _this = this;
        console.log({ status: status });
        if (!status) {
            return;
        }
        this.isLoggedIn = status.status;
        //this.searchLogginIn ? this.searchLogginIn.nativeElement.style.display = 'none' : '';
        if (this.isMobile) {
            setTimeout(function () {
                if (_this.isLoggedIn) {
                    _this.searchNotLoggedIn ? (_this.searchNotLoggedIn.nativeElement.style.display = 'none') : '';
                    _this.searchLogginIn ? (_this.searchLogginIn.nativeElement.style.display = 'block') : '';
                    _this.loginIcon && (_this.loginIcon.nativeElement.style.width = '10%');
                    _this.loginBtnLoggedIn ? (_this.loginBtnLoggedIn.nativeElement.style.display = 'block') : '';
                    _this.loginBtnNotLoggedIn ? (_this.loginBtnNotLoggedIn.nativeElement.style.display = 'none') : '';
                    if (_this.sidebar && _this.sidebar.countBaseIcon) {
                        _this.sidebar.countBaseIcon.nativeElement.style.visibility = 'visible';
                    }
                    //this.featuresToggle.multipleCities ? this.loginTip.nativeElement.style.display = 'none' : '';
                    setTimeout(function () {
                        _this.profileImage = status.profileImg;
                        _this.profile ? (_this.profile.nativeElement.src = _this.profileImage) : '';
                        _this.FBLoggedIn();
                    });
                }
                else {
                    setTimeout(function () {
                        _this.searchNotLoggedIn ? (_this.searchNotLoggedIn.nativeElement.style.display = 'block') : '';
                        _this.searchLogginIn ? (_this.searchLogginIn.nativeElement.style.display = 'none') : '';
                        _this.loginIcon && (_this.loginIcon.nativeElement.style.width = '100%');
                        _this.loginBtnLoggedIn ? (_this.loginBtnLoggedIn.nativeElement.style.display = 'none') : '';
                        //(this.loginBtnLoggedIn && !this.featuresToggle.multipleCities) ? this.loginBtnLoggedIn.nativeElement.style.display = 'none' : '';
                        _this.loginBtnNotLoggedIn ? (_this.loginBtnNotLoggedIn.nativeElement.style.display = 'block') : '';
                        if (_this.sidebar && _this.sidebar.countBaseIcon) {
                            _this.sidebar.countBaseIcon.nativeElement.style.visibility = 'visible';
                        }
                        _this.profileImage = null;
                        _this.FBLoggedIn();
                        //this.showLoginTip();
                    }, 1100);
                }
            });
        }
        else {
            setTimeout(function () {
                _this.FBLoggedIn();
            }, 2000);
        }
    };
    VisitorTripComponent.prototype.closeLoginTip = function () {
        this.featuresToggle.multipleCities ? (this.loginTip.nativeElement.style.display = 'none') : '';
        this.loginBtnLoggedIn ? (this.loginBtnLoggedIn.nativeElement.style.position = 'initial') : '';
        this.loginBtnWrap ? (this.loginBtnWrap.nativeElement.style.position = 'initial') : '';
    };
    VisitorTripComponent.prototype.showLoginTip = function () {
        // let isShown = localStorage.getItem(localStorageKeys.tripPlannerLoadingTip);
        // if (isShown) {
        //     return;
        // }
        // console.log(document.cookie);
        //
        // document.cookie = "{tripPlannerLoadingTip: {isShown: true}}";
        // console.log(document.cookie);
        this.featuresToggle.multipleCities ? (this.loginTip.nativeElement.style.display = 'block') : '';
        //localStorage.setItem(localStorageKeys.tripPlannerLoadingTip, JSON.stringify({ isShown: true }));
    };
    VisitorTripComponent.prototype.goBack = function () {
        var _this = this;
        // this.sidebar.switchToEvents();
        this.isShowSidebarOnMobile = false;
        setTimeout(function () {
            _this.isShowDirectionMap = false;
            _this.isShowNormalMap = false;
            _this.isShowTour = false;
        });
    };
    VisitorTripComponent.prototype.start = function () {
        var _this = this;
        if (!this.isMobile) {
            if (!this.sidebar.events || !this.sidebar.events.length) {
                this.isShowWelcomepageNoEventTip = true;
                return;
            }
            this.isShowNormalMap = true;
            this.isInfoWindowsOpen = [];
            this.sidebar.events.filter(function (x) { return !x.isOnlineEvent; });
            this.items = this.sidebar.setEventMapIcon(this.sidebar.events || []);
            for (var i = 0; i < this.items.length; i++) {
                this.isInfoWindowsOpen.push(false);
            }
            if (this.items.length > 1) {
                this.googleMapService.fitBounds(this.items).subscribe(function (data) {
                    _this.latLngBounds = data;
                });
            }
        }
        else {
            if (!this.from && !this.to) {
                this.showEvents();
            }
            else {
                this.isShowSidebarOnMobile = true;
                this.visitorApiService
                    .getEvents(this.hubName, {
                    limit: config.searchLimit,
                    page: 1,
                    category: 'all',
                    from: this.from,
                    to: this.to,
                })
                    .subscribe(function (data) {
                    VisitorDataCache.events = data;
                    _this.sidebar.afterGotEvents(data);
                });
            }
        }
        this.isStarted = true;
    };
    VisitorTripComponent.prototype.scrollToTop = function () {
        this.tripWrap.nativeElement.scrollTop = 0;
    };
    VisitorTripComponent.prototype.setMapCenter = function (lat, lng) {
        this.lat = lat;
        this.lng = lng;
    };
    VisitorTripComponent.prototype.gotoDetails = function (item) {
        this.sidebar.showDetails(item, item.startTime ? 'event' : 'place', false);
        if (this.isMobile) {
            this.invisiblePopup();
        }
    };
    VisitorTripComponent.prototype.removeFromTrip = function (item) {
        this.sidebar.attractionlist.removeFromList(item._id);
    };
    VisitorTripComponent.prototype.showEvents = function () {
        var _this = this;
        if (this.isMobile) {
            this.isShowSidebarOnMobile = true;
        }
        setTimeout(function () {
            _this.sidebar.switchToEvents(true);
        });
    };
    VisitorTripComponent.prototype.showPlaces = function () {
        var _this = this;
        if (this.isMobile) {
            this.isShowSidebarOnMobile = true;
        }
        setTimeout(function () {
            _this.sidebar.switchToPlaces();
        });
    };
    VisitorTripComponent.prototype.showToursView = function () {
        var _this = this;
        if (this.isMobile) {
            this.isShowSidebarOnMobile = true;
        }
        setTimeout(function () {
            _this.sidebar.switchToTours();
        });
    };
    VisitorTripComponent.prototype.showTrips = function () {
        var _this = this;
        if (this.isMobile) {
            this.isShowSidebarOnMobile = true;
        }
        setTimeout(function () {
            _this.sidebar.switchToTrip();
        });
    };
    VisitorTripComponent.prototype.searchCity = function (searchText) {
        this.searchCityText = searchText;
        return this.visitorApiService.searchCities(this.hubName, this.searchCityText);
    };
    VisitorTripComponent.prototype.searchCityResultSelect = function (selectedItem) {
        var _this = this;
        var inThisRegion = null;
        for (var _i = 0, _a = this.allRegions; _i < _a.length; _i++) {
            var region = _a[_i];
            if (region.cities.any(function (city) { return city.id === selectedItem.id; })) {
                inThisRegion = region;
                break;
            }
        }
        if (inThisRegion) {
            this.setSelectedRegion(inThisRegion.id);
            this.processRegion(inThisRegion, selectedItem.id);
        }
        else {
            this.loadingRegion = true;
            this.visitorApiService.getRegionByCity(this.hubName, selectedItem.id).subscribe(function (region) {
                _this.loadingRegion = false;
                if (region) {
                    _this.setSelectedRegion(region.id);
                    _this.processRegion(region, selectedItem.id);
                }
                else {
                    alert('This city is not in any region');
                }
            });
        }
        this.citySearch.clearSearchText();
    };
    VisitorTripComponent.prototype.clearSearchText = function () {
        this.searchText = '';
        this.sidebar.search(this.searchText, this.from, this.to);
    };
    VisitorTripComponent.prototype.search = function () {
        this.sidebar.search(this.searchText, this.from, this.to);
    };
    VisitorTripComponent.prototype.filterEvents = function () {
        if (!this.isMobile) {
            this.sidebar.filterEventsByDate(this.searchText, this.from, this.to);
            this.isShowWelcomepageNoEventTip = false;
        }
        else {
            // this.visitorApiService.getEvents(this.hubName,
            //     {
            //         limit: config.searchLimit,
            //         page: 1,
            //         category: 'all',
            //         search: searchText,
            //         from,
            //         to
            //     }).subscribe(data => {
            //     EventTimeService.formatEventTime(data);
            //     this.allEventsOrPlaces = data;
            //     this.setPaggination(data);
            //     this.hideMask();
            // });
        }
    };
    VisitorTripComponent.prototype.invisiblePopup = function () {
        // if (this.popup) {
        //     this.popup.nativeElement.style.top = this.popup.nativeElement.style.height;
        // }
    };
    VisitorTripComponent.prototype.visiblePopup = function () {
        if (this.popup && (this.isShowNormalMap || this.isShowDirectionMap)) {
            this.popup.nativeElement.style.top = '0px';
        }
    };
    VisitorTripComponent.prototype.showPopup = function () {
        var _this = this;
        setTimeout(function () {
            _this.popup.nativeElement.style.top = '0px';
        });
    };
    VisitorTripComponent.prototype.hidePopup = function () {
        this.popup.nativeElement.style.top = this.popup.nativeElement.style.height;
        if (this.direction && !isNullOrUndefined(this.direction.currentIndex)) {
            this.direction.currentIndex = null;
        }
        this.isShowNormalMap = false;
        this.isShowDirectionMap = false;
    };
    VisitorTripComponent.prototype.searchItemInTourOrTrip = function (searchText) {
        if (!searchText) {
            return;
        }
        var items = [];
        var targets = [];
        if (this.sidebar.displayingOn === 'tour') {
            if (this.sidebar.currentTour) {
                targets = this.sidebar.currentTour.attractions;
            }
        }
        else if (this.sidebar.displayingOn === 'trip') {
            if (this.sidebar.trips) {
                targets = this.sidebar.trips.attractions;
            }
        }
        for (var _i = 0, targets_1 = targets; _i < targets_1.length; _i++) {
            var item = targets_1[_i];
            if (item.item.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) {
                items.push(item.item);
            }
        }
        return Observable.create(function (observable) {
            observable.next(items);
            observable.complete();
        });
    };
    VisitorTripComponent.prototype.searchResultSelectedInTourOrTrip = function (selectedItem) {
        var index = 0;
        var targets = [];
        if (this.sidebar.displayingOn === 'tour') {
            if (this.sidebar.currentTour) {
                targets = this.sidebar.currentTour.attractions;
            }
        }
        else if (this.sidebar.displayingOn === 'trip') {
            if (this.sidebar.trips) {
                targets = this.sidebar.trips.attractions;
            }
        }
        for (var _i = 0, targets_2 = targets; _i < targets_2.length; _i++) {
            var item = targets_2[_i];
            if (item.item._id === selectedItem._id) {
                break;
            }
            index++;
        }
        this.direction.showInfoWindowByIndex(index);
    };
    VisitorTripComponent.prototype.floatDetailPlaceFeedsRetrieved = function ($event) {
        var _this = this;
        if (!this.isShowfloatDetailPlaceFeeds) {
            this.isShowfloatDetailPlaceFeeds = true;
        }
        if ($event) {
            setTimeout(function () {
                _this.setMapCenter($event.item.address.lat || $event.item.lat, $event.item.address.lng || $event.item.lng);
            }, 500);
        }
    };
    VisitorTripComponent.prototype.showOnMap = function ($event) {
        // if (this.isMobile) {
        //     this.googleMapService.getGoogle().then(() => {
        //         this.isShowSelectedMarker = true;
        //     });
        // }
        var _this = this;
        this.isInfoWindowsOpen = [];
        $event.items = $event.items.filter(function (x) { return !x.isOnlineEvent; });
        this.items = $event.items;
        for (var i = 0; i < this.items.length; i++) {
            this.isInfoWindowsOpen.push(false);
        }
        if (this.items.length > 1) {
            this.googleMapService.fitBounds(this.items).subscribe(function (data) {
                _this.latLngBounds = data;
            });
        }
        setTimeout(function () {
            _this.isShowNormalMap = true;
            _this.isShowTour = false;
            _this.isShowDirectionMap = false;
            if (_this.isMobile) {
                _this.googleMapService.getGoogle().then(function () {
                    _this.mapBottomInfoItem = _this.items[$event.index];
                    _this.mapBottomInfoIndex = -1;
                    _this.showPopup();
                    setTimeout(function () {
                        _this.mapBottomInfo.show();
                    });
                });
            }
            else {
                if (!isNullOrUndefined($event.index)) {
                    _this.isInfoWindowsOpen[$event.index] = true;
                }
            }
        });
    };
    VisitorTripComponent.prototype.normalMapReady = function () {
        var _this = this;
        setTimeout(function () {
            _this.isNormalMapReady = true;
        });
    };
    VisitorTripComponent.prototype.startPlan = function () {
        this.isPlanStarted = true;
        if (this.mapBottomInfo) {
            this.mapBottomInfo.close();
        }
    };
    VisitorTripComponent.prototype.mapMarkerClick = function (item) {
        if (this.isMobile) {
            this.mapBottomInfoItem = item;
            this.mapBottomInfoIndex = -1;
            this.mapBottomInfo.show();
        }
    };
    VisitorTripComponent.prototype.showInfoWindowByIndex = function (index) {
        var _this = this;
        if (!this.isMobile) {
            this.hideAllSingleInfoWindow();
            setTimeout(function () {
                _this.isInfoWindowsOpen[index] = true;
            });
        }
    };
    VisitorTripComponent.prototype.drawDirectionRoute = function (tour) {
        this.tripTour = new HubTour();
        if (tour) {
            tour.attractions.forEach(function (x, index) {
                x.order = index;
            });
            this.tripTour = tour;
            this.tripTour.isEventImageProcessed = true;
        }
        else {
            var userID = null;
            if (SocialLoginPopupComponent.isUserLoggedIn) {
                userID = SocialLoginPopupComponent.userId;
            }
            var isShared = false;
            if (this.urlTripID) {
                userID = this.urlTripFromUserID;
                isShared = true;
            }
            var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userID, isShared);
            var trip = JSON.parse(localStorage.getItem(key));
            if (!trip) {
                trip = new TripStorageCommand();
                trip.trips = [];
            }
            else {
                trip.trips = trip.trips.removeDuplicate();
                trip.trips.forEach(function (x) {
                    x.attractions = x.attractions.removeDuplicate();
                });
            }
            // this.tripTour.attractions = [];
            // trip.attractions.forEach((x, index) => {
            //     let item = new Attraction();
            //     item.item = x.item;
            //     item.order = index;
            //     this.tripTour.attractions.push(item);
            // });
        }
    };
    VisitorTripComponent.prototype.showDirectionMap = function (tour) {
        var _this = this;
        this.drawDirectionRoute(tour);
        if (this.isShowDirectionMap) {
            setTimeout(function () {
                _this.direction.drawFullRoute();
                if (_this.isMobile) {
                    _this.showPopup();
                }
            });
        }
        else {
            this.isShowDirectionMap = true;
            if (this.isMobile) {
                this.showPopup();
            }
        }
        this.isShowNormalMap = false;
    };
    VisitorTripComponent.prototype.hideMap = function () {
        this.isShowDirectionMap = false;
        this.mobilesearch.clearSearchText();
    };
    VisitorTripComponent.prototype.mapReady = function () {
        if (this.direction) {
            this.direction.ready();
        }
    };
    VisitorTripComponent.prototype.reorder = function ($event) {
        this.showDirectionMap($event);
    };
    VisitorTripComponent.prototype.afterRemoveFromTrip = function (trip) {
        var _this = this;
        if (!this.isMobile) {
            if (this.sidebar.displayingOn === 'trip') {
                this.showDirectionMap(trip);
            }
        }
        else {
            if (this.isShowDirectionMap) {
                this.drawDirectionRoute(trip);
                setTimeout(function () {
                    _this.direction.drawFullRoute();
                });
                this.direction.currentIndex = null;
            }
        }
    };
    VisitorTripComponent.prototype.showTours = function (tours) {
        var _this = this;
        this.tours = tours;
        this.isShowDirectionMap = false;
        this.isShowTour = true;
        if (!this.isMobile) {
            setTimeout(function () {
                if (tours && tours.length) {
                    _this.isNoContent = false;
                    _this.waterFallContainer.startLoading();
                    _this.waterFallContainer.reLayout();
                }
                else {
                    _this.isNoContent = true;
                }
            }, 200);
        }
    };
    VisitorTripComponent.prototype.selectRegion = function (target) {
        var _this = this;
        console.log(target);
        this.noCities = false;
        this.isMultiCityBlock && this.blockNavigator.scrollToStart();
        if (target.value === 'all') {
            if (this.allRegionsInOne.cities && this.allRegionsInOne.cities.length) {
                this.allRegionsInOne.cities = this.allRegionsInOne.cities.sortBy(function (x) { return x.cityTitle; });
                this.currentRegion = this.allRegionsInOne;
                if (this.isMultiCityBlock) {
                    this.blockNavigator.setSelectedCity(this.allRegionsInOne.cities[0]);
                    this.blockNavigator.getIsNeedScroll();
                    this.gotoCity({ id: this.allRegionsInOne.cities[0].id });
                }
            }
            else {
                this.noCities = true;
            }
            return;
        }
        if (this.allRegions) {
            var region_1 = this.allRegions.first(function (x) { return x.id === target.value; });
            if (region_1 && region_1.cities.length) {
                this.processRegion(region_1);
            }
            else {
                this.loadingRegion = true;
                this.visitorApiService.getRegion(this.hubName, region_1.id).subscribe(function (data) {
                    _this.loadingRegion = false;
                    region_1 = data;
                    var index = _this.allRegions.getElementIndex(function (x) { return x.id === target.value; });
                    _this.allRegions[index] = region_1;
                    _this.processRegion(region_1);
                });
            }
        }
    };
    VisitorTripComponent.prototype.gotoCity = function ($event, isGotoTours) {
        if (isGotoTours === void 0) { isGotoTours = false; }
        console.log($event);
        //this.pageSpinner.show();
        this.sidebar.showMask();
        var feedId = $event.id;
        this.sidebar.resetPlaceCategoty();
        this.sidebar.switchToPlaces(false, feedId, isGotoTours);
        //this.sidebar.hideMask();
        // this.visitorApiService.getPlaces(this.hubName, {
        //     feedId,
        //     category: 'all'
        // }).subscribe(data => {
        //     console.log(`place count: ${data.length}`);
        //     VisitorDataCache.places = data;
        //     setTimeout(() => {
        //         this.sidebar.switchToPlaces(false, feedId);
        //         this.sidebar.hideMask();
        //     }, 500);
        // });
    };
    VisitorTripComponent.prototype.setPDFLoadingTip = function (array) {
        if (this.isForExportPDF) {
            this.loadingTip = 'Loading PDF...' + array.getRandom() + '%';
        }
    };
    VisitorTripComponent.prototype.showTourDetail = function (tour) {
        var _this = this;
        var travelTime = tour.travelTime || null;
        var distance = tour.distance || null;
        this.visitorApiService.getTourDetail(this.hubName, tour._id, true).subscribe(function (data) {
            _this.setPDFLoadingTip([13, 14, 15, 16]);
            var items = [];
            data.attractions.forEach(function (item) {
                if (item.status !== 'not found') {
                    items.push(item);
                }
            });
            data.attractions = items;
            if (_this.isEventEnabled) {
                _this.getEventsFromCache().subscribe(function (events) {
                    data.attractions = _this.processDefaultImages(data);
                    _this.processForOpeningTour(data, travelTime, distance);
                });
            }
            else {
                _this.processForOpeningTour(data, travelTime, distance);
            }
        });
    };
    VisitorTripComponent.prototype.loadMore = function () { };
    VisitorTripComponent.prototype.processForOpeningTour = function (data, travelTime, distance) {
        this.tripTour = data;
        this.tripTour.travelTime = travelTime;
        this.tripTour.distance = distance;
        this.tripTour.isEventImageProcessed = true;
        this.sidebar && this.sidebar.showTourDetail(data);
        if (!this.isMobile) {
            this.isShowDirectionMap = true;
        }
        else {
            this.sidebar.hideTourSpinner();
        }
        if (this.isForExportPDF) {
            this.sidebar.printTour(this.isPrintVersion);
        }
    };
    // 10214072230112487
    VisitorTripComponent.prototype.FBLoggedIn = function () {
        //this.syncTripsWithDB('10214072230112487');
        if (!this.urlTripID) {
            if (SocialLoginPopupComponent.isUserLoggedIn) {
                var userID = SocialLoginPopupComponent.userId;
                this.syncTripsWithDB(userID);
            }
            else {
            }
        }
        else {
            if (SocialLoginPopupComponent.isUserLoggedIn) {
                this.syncSharedTripsWithDB(SocialLoginPopupComponent.userId);
            }
        }
    };
    VisitorTripComponent.prototype.syncTripsWithDB = function (userID) {
        var _this = this;
        this.getTripsFromDB(userID).subscribe(function (tripsInDB) {
            console.log('tripsInDB', tripsInDB);
            var tripsInCookie = _this.getUserTripInCookie(userID);
            console.log('tripsInCookie', tripsInCookie);
            if (tripsInDB && tripsInDB.updateTime) {
                if (tripsInCookie && tripsInCookie.updateTime) {
                    if (tripsInDB.updateTime < tripsInCookie.updateTime) {
                        tripsInCookie.userFacebookId = userID;
                        tripsInCookie.id = tripsInDB.id;
                        tripsInDB.trips = tripsInCookie.trips;
                        _this.updateTripToDB(tripsInCookie, userID);
                    }
                    else {
                        tripsInDB.timestamp = new Date();
                    }
                }
                else {
                    tripsInDB.timestamp = new Date();
                }
                _this.setLocalStorage(tripsInDB, userID);
                _this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripsInDB.id));
            }
            else if (!tripsInDB) {
                if (tripsInCookie && tripsInCookie.timestamp) {
                    _this.createTripInDB(userID, tripsInCookie).subscribe(function (tripId) {
                        _this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripsInDB.id));
                    });
                    _this.setLocalStorage(tripsInCookie, userID);
                }
            }
            setTimeout(function () {
                _this.sidebar && _this.sidebar.getTripCount(userID);
            });
        });
    };
    VisitorTripComponent.prototype.GoogleSignIn = function () { };
    VisitorTripComponent.prototype.onSignIn = function (googleUser) {
        var profile = googleUser.getBasicProfile();
        console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
        console.log('Name: ' + profile.getName());
        console.log('Image URL: ' + profile.getImageUrl());
        console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
    };
    VisitorTripComponent.prototype.syncTripsWithDBAsync = function (userID) {
        var _this = this;
        return Observable.create(function (observer) {
            if (userID) {
                _this.getTripsFromDB(userID).subscribe(function (tripsInDB) {
                    var tripsInCookie = _this.getUserTripInCookie(userID);
                    if (tripsInDB && tripsInDB.timestamp) {
                        if (tripsInCookie && tripsInCookie.timestamp) {
                            if (tripsInDB.timestamp < tripsInCookie.timestamp) {
                                tripsInCookie.userFacebookId = userID;
                                tripsInCookie.id = tripsInDB.id;
                                tripsInDB.trips = tripsInCookie.trips;
                                _this.updateTripToDB(tripsInCookie, userID);
                            }
                            else {
                                tripsInDB.timestamp = new Date();
                            }
                        }
                        else {
                            tripsInDB.timestamp = new Date();
                        }
                        _this.setLocalStorage(tripsInDB, userID);
                        _this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripsInDB.id));
                        observer.next(tripsInDB);
                        observer.complete();
                    }
                    else {
                        if (tripsInCookie && tripsInCookie.timestamp) {
                            _this.createTripInDB(userID, tripsInCookie).subscribe(function (tripId) {
                                _this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripsInDB.id));
                            });
                            _this.setLocalStorage(tripsInCookie, userID);
                            observer.next(tripsInCookie);
                            observer.complete();
                        }
                    }
                    setTimeout(function () {
                        _this.sidebar.getTripCount(userID);
                    });
                });
            }
            else {
                observer.next(null);
                observer.complete();
            }
        });
    };
    VisitorTripComponent.prototype.syncSharedTripsWithDB = function (userID) {
        var _this = this;
        if (userID === this.urlTripFromUserID) {
            this.getTripsFromDB(userID).subscribe(function (tripsInDB) {
                var tripsInCookie = _this.getSharedUserTripInCookie();
                if (tripsInDB && tripsInDB.timestamp) {
                    if (tripsInCookie && tripsInCookie.timestamp) {
                        if (tripsInDB.timestamp < tripsInCookie.timestamp) {
                            tripsInCookie.userFacebookId = userID;
                            tripsInCookie.id = tripsInDB.id;
                            tripsInDB.attractions = tripsInCookie.attractions;
                            _this.updateTripToDB(tripsInCookie, userID);
                        }
                        else {
                            tripsInDB.timestamp = new Date();
                        }
                    }
                    else {
                        tripsInDB.timestamp = new Date();
                    }
                    _this.setLocalStorage(tripsInDB, userID);
                    _this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripsInDB.id));
                }
                else {
                    if (tripsInCookie && tripsInCookie.timestamp) {
                        _this.createTripInDB(userID, tripsInCookie).subscribe(function (tripId) {
                            _this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripId));
                        });
                        _this.setLocalStorage(tripsInCookie, userID);
                    }
                }
                setTimeout(function () {
                    _this.sidebar.getTripCount(userID);
                });
            });
        }
        else {
            // this.getTripsFromDB(this.urlTripFromUserID).subscribe(tripsInDB => {
            //     let tripsInCookie = this.getSharedUserTripInCookie();
            //     if (tripsInDB) {
            //         tripsInCookie.userFacebookId = this.urlTripFromUserID;
            //         tripsInCookie.id = tripsInDB.id;
            //         tripsInDB.attractions = tripsInCookie.attractions;
            //         this.updateTripToDB(tripsInCookie, userID);
            //         this.setLocalStorageForSharedTrip(tripsInDB, this.urlTripFromUserID);
            //     } else {
            //         this.createTripInDB(userID, tripsInCookie).subscribe(tripId => {
            //             this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripId));
            //         });
            //         this.setLocalStorageForSharedTrip(tripsInCookie, this.urlTripFromUserID);
            //     }
            // });
        }
    };
    VisitorTripComponent.prototype.setSelectedRegion = function (id) {
        this.regionSource.forEach(function (x) { return (x.selected = false); });
        this.regionSelect.setSelected(id);
    };
    VisitorTripComponent.prototype.processRegion = function (region, gotoThisCity) {
        var _this = this;
        region.cities = region.cities.sortBy(function (x) { return x.cityTitle; });
        this.currentRegion = region;
        if (region.cities && region.cities.length) {
            setTimeout(function () {
                if (gotoThisCity) {
                    _this.blockNavigator.setSelectedCityById(gotoThisCity);
                    _this.blockNavigator.scrollToCity(gotoThisCity);
                }
                else {
                    _this.isMultiCityBlock && _this.blockNavigator.setSelectedCity(region.cities[0]);
                }
                if (_this.isMultiCityBlock) {
                    _this.blockNavigator.getIsNeedScroll();
                    _this.gotoCity({ id: gotoThisCity || region.cities[0].id });
                }
                else {
                    _this.sidebar.resetPlaceCategoty();
                    VisitorDataCache.tours = null;
                    _this.sidebar.switchToPlaces();
                }
            });
        }
        else {
            this.noCities = true;
        }
    };
    VisitorTripComponent.prototype.getTripsFromDB = function (userID) {
        return this.visitorApiService.getUserTrips(this.hubName, userID);
    };
    VisitorTripComponent.prototype.getTripsFromDBByTripID = function (tripID) {
        return this.visitorApiService.getUserTripByTripID(this.hubName, tripID);
    };
    VisitorTripComponent.prototype.setLocalStorage = function (trips, userID) {
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userID);
        localStorage.setItem(keyWithUserID, JSON.stringify(trips));
        localStorage.setItem(key, JSON.stringify(trips));
        if (this.sidebar && this.sidebar.displayingOn === 'trip') {
            this.sidebar.switchToTrip();
        }
        //localStorage.removeItem(key);
    };
    VisitorTripComponent.prototype.setLocalStorageForSharedTrip = function (trips, fromUserID, switchToTrip) {
        var _this = this;
        // if (FacebookLoginButtonComponent.isUserLoggedIn && fromUserID === FacebookLoginButtonComponent.authResponse.authResponse.userID) {
        if (SocialLoginPopupComponent.isUserLoggedIn && fromUserID === SocialLoginPopupComponent.userId) {
            this.setLocalStorage(trips, fromUserID);
            if (switchToTrip) {
                if (this.isMobile) {
                    this.isShowSidebarOnMobile = true;
                }
                setTimeout(function () {
                    _this.sidebar.switchToTrip(true);
                });
            }
        }
        else {
            var keyWithUserIDShared = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, fromUserID, true);
            localStorage.setItem(keyWithUserIDShared, JSON.stringify(trips));
            if (switchToTrip) {
                if (this.isMobile) {
                    this.isShowSidebarOnMobile = true;
                }
                setTimeout(function () {
                    _this.sidebar.switchToTrip(true);
                });
            }
        }
    };
    VisitorTripComponent.prototype.getUserTripInCookie = function (userID) {
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userID);
        var storage = localStorage.getItem(key);
        var storageWithUserID = localStorage.getItem(keyWithUserID);
        var tripsInCookie = JSON.parse(storage);
        var tripsInCookieWithUserID = JSON.parse(storageWithUserID);
        if (tripsInCookie && !tripsInCookieWithUserID) {
            return tripsInCookie;
        }
        if (!tripsInCookie && tripsInCookieWithUserID) {
            return tripsInCookieWithUserID;
        }
        if (!tripsInCookie && !tripsInCookieWithUserID) {
            return null;
        }
        if (tripsInCookie && tripsInCookieWithUserID) {
            if (!tripsInCookie.updateTime || !tripsInCookieWithUserID.updateTime) {
                return tripsInCookieWithUserID;
            }
            return tripsInCookie.updateTime < tripsInCookieWithUserID.updateTime ? tripsInCookieWithUserID : tripsInCookie;
        }
    };
    VisitorTripComponent.prototype.getSharedUserTripInCookie = function () {
        var keyWithUserIDShared = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.urlTripFromUserID, true);
        var storageWithUserID = localStorage.getItem(keyWithUserIDShared);
        var tripsInCookieWithUserID = JSON.parse(storageWithUserID);
        return tripsInCookieWithUserID;
    };
    VisitorTripComponent.prototype.createTripInDB = function (userID, tripsInCookie) {
        var _this = this;
        return Observable.create(function (observer) {
            var command = new CreateTripCommand();
            command.id = guid();
            command.userFacebookId = userID;
            command.hubName = _this.hubName;
            command.timestamp = new Date();
            command.attractions = tripsInCookie.attractions;
            // this.visitorApiService.createTrip(this.hubName, command).subscribe(() => {
            //         observer.next(command.id);
            //         observer.complete();
            //     }
            // );
        });
    };
    VisitorTripComponent.prototype.updateTripToDB = function (tripsInCookie, userID) {
        tripsInCookie.trips.forEach(function (x) {
            if (!x.id) {
                x.id = guid();
            }
        });
        this.visitorApiService.updateTrip(this.hubName, tripsInCookie).subscribe();
    };
    VisitorTripComponent.prototype.hideAllSingleInfoWindow = function () {
        if (this.isInfoWindowsOpen && this.isInfoWindowsOpen.length) {
            for (var i = 0; i < this.isInfoWindowsOpen.length; i++) {
                this.isInfoWindowsOpen[i] = false;
            }
        }
    };
    VisitorTripComponent.prototype.processDefaultImages = function (data) {
        if (!data || !data.attractions) {
            return [];
        }
        var items = [];
        data.attractions.forEach(function (item) {
            if (item.status.toLowerCase() === 'ok') {
                // for those events use default images, need to load image from events cache
                if (!item.item.cover) {
                    var itemInCache = VisitorDataCache.events.first(function (x) { return x._id === item.feedId; });
                    if (itemInCache && itemInCache.cover) {
                        item.item.cover = itemInCache.cover;
                    }
                }
                items.push(item);
            }
        });
        return items;
    };
    VisitorTripComponent.prototype.getEventsFromCache = function () {
        var _this = this;
        return Observable.create(function (observable) {
            var events = VisitorDataCache.events;
            if (events && events.length) {
                observable.next(events);
                observable.complete();
            }
            else {
                _this.visitorApiService
                    .getEvents(_this.hubName, {
                    limit: config.searchLimit,
                    page: 1,
                    category: 'all',
                })
                    .subscribe(function (data) {
                    VisitorDataCache.events = data;
                    observable.next(data);
                    observable.complete();
                });
            }
        });
    };
    VisitorTripComponent.prototype.setMultipleCities = function (command, regionId) {
        var _this = this;
        // this.regionSource = [{
        //     text: 'Select a Region',
        //     value: 'all',
        //     selected: !regionId
        // }];
        this.regionSource = [];
        command.regions.forEach(function (x, index) {
            if (!_this.regionSource.any(function (y) { return y.value === x.id; })) {
                _this.regionSource.push({
                    text: x.name,
                    value: x.id,
                    selected: x.id === regionId || (!regionId && index === 0),
                });
            }
        });
        this.allRegions = clone(command.regions);
        this.allRegionsInOne.cities = [];
        if (!regionId) {
            command.regions.forEach(function (x) {
                x.cities.forEach(function (e) {
                    if (!_this.allRegionsInOne.cities.any(function (y) { return y.id === e.id; })) {
                        _this.allRegionsInOne.cities.push(e);
                    }
                });
            });
            this.allRegionsInOne.cities = this.allRegionsInOne.cities.sortBy(function (x) { return x.cityTitle; });
            this.currentRegion = this.allRegionsInOne;
        }
        else {
            var regionFromUrl = command.regions.first(function (x) { return x.id === regionId; });
            if (regionFromUrl) {
                regionFromUrl.cities = regionFromUrl.cities.sortBy(function (x) { return x.cityTitle; });
                this.currentRegion = regionFromUrl;
            }
            else {
                this.modalService.showErrorModal('Region id is wrong!');
                return;
            }
        }
        if (this.isMobile) {
            this.isShowSidebarOnMobile = true;
        }
        if (this.isMultiCityBlock) {
            if (this.currentRegion.cities && this.currentRegion.cities.length) {
                setTimeout(function () {
                    _this.blockNavigator.setSelectedCity(_this.currentRegion.cities[0]);
                    if (!_this.urlTripID && !_this.isForExportPDF) {
                        _this.gotoCity({ id: _this.currentRegion.cities[0].id }, false);
                    }
                });
            }
            else {
                this.noCities = true;
            }
        }
        else {
            setTimeout(function () {
                _this.sidebar.switchToTours();
            });
        }
    };
    return VisitorTripComponent;
}(BaseComponent));
export { VisitorTripComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/visitor.trip.component.ts.pre-build-optimizer.js